export default {
    subtitle: "Everything you need, in one place.",
    visit: "The booking",
    visitHint: "Choose a date, party size and time.",
    date: "Booking date",
    adults: "Adults",
    children: "Children",
    guests: "Guests",
    schedule: "Time",
    scheduleHint: "Numbers show guests already booked.",
    chooseSlot: "Choose a time",
    noSlots: "No times available on this date. Try another day.",
    loadingSlots: "Loading times…",
    loadingContext: "Loading establishment settings…",
    retry: "Try again",
    client: "The customer",
    clientHint: "Find an existing customer or enter their details.",
    searchClient: "Find an existing customer",
    searchPlaceholder: "Name, phone number or email",
    searching: "Searching…",
    noClient: "No customer found. Enter a new customer’s details below.",
    selectedClient: "Existing customer selected",
    changeClient: "Change customer",
    clientUpdate: "Contact changes will be saved to this customer’s profile.",
    contactMatch: "A customer profile already uses these contact details.",
    dismissContactMatch: "Dismiss reminder",
    useContactMatch: "Use {name}’s profile",
    moreClient: "Additional customer information",
    clientCoordinates: "Customer details",
    newClient: "Enter a new customer",
    expandClient: "Show",
    collapseClient: "Collapse",
    placement: "Seating and extras",
    placementHint: "Tables, menus and extras for this booking.",
    placementPending: "Checking seating…",
    placementUnavailable: "Automatic seating is unavailable. Choose a table or explicitly ignore seating.",
    requestFailed: "The check could not be completed. Try again for up-to-date information.",
    capacityPending: "Checking capacity…",
    capacityAvailable: "Capacity checked",
    summary: "Summary",
    details: "Details and preferences",
    payment: "Confirmation and guarantee",
    saveType: "Save as",
    booking: "Booking",
    option: "Option",
    waiting: "Waiting list",
    waitingFiles: "The waiting list does not support attachments. Remove the files or save a booking to keep them.",
    save: "Create booking",
    saveOption: "Save option",
    saveWaiting: "Add to waiting list",
    saving: "Saving…",
    invalid: "Check the highlighted fields before saving.",
    readyHint: "Choose a time to complete the booking.",
    extras: "Extras total",
    optional: "Optional",
    changeRestaurant: "Another establishment",
    close: "Close booking form",
    discard: "Discard the information you entered?",
    keepEditing: "Keep editing",
    guaranteeHint: "The guarantee request follows the establishment’s notification settings.",
    discardConfirm: "Discard",
    tableCheck: "Checking tables",
    loadFailed: "Unable to load this information.",
    menusLoadFailed: "Unable to load the services offered for this time slot.",
    generalOptionsLoadFailed: "Unable to load the general options for this time slot.",
    confirmationNeedsEmail: "Add the customer's email to send them a confirmation.",
    confirmationNeedsPhone: "Add the customer's phone number to send them a confirmation.",
    blockers: {
        loading: "Checks in progress…",
        loadFailed: "Some information could not be loaded. Use “Retry” in the relevant section.",
        slot: "Select a time slot to create the reservation.",
        guests: "Enter at least one adult.",
        waitingFiles: "Remove the attachments to add the customer to the waiting list.",
        tableUnavailable: "A selected table is no longer available. Change the selection.",
        tableRequired: "Choose a table or tick “Ignore the seating placement”.",
    },
    tables: {
        title: "Choose tables",
        hint: "Select a table or a group in the room you want.",
        table: "Table",
        group: "Group",
        seats: "seats",
        selected: "Selected tables",
        chosen: "Selected",
        remove: "Remove {table} · {room}",
        search: "Search for a table or room",
        room: "Room",
        allRooms: "All rooms",
        noResults: "No tables match your search.",
        empty: "No tables are configured for this time.",
        unavailable: "Unavailable at this time",
        differentRoom: "Choose within the same room",
        overlap: "Table already included in the selection",
        enoughSeats: "Enough seats already selected",
    },
};
